package com.ijoin.util.datetime

import kotlinx.datetime.Instant
import kotlinx.datetime.LocalDate
import kotlinx.datetime.LocalDateTime
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime

fun Instant.toLocalDateCompat(timeZone: TimeZone = TimeZone.currentSystemDefault()): LocalDate =
    toLocalDateTime(timeZone).date

fun Instant.toLocalDateCompat(timeZoneId: String?): LocalDate {
    val tz = timeZoneId?.let {
        try { TimeZone.of(it) } catch (_: Exception) { TimeZone.currentSystemDefault() }
    } ?: TimeZone.currentSystemDefault()
    return toLocalDateTime(tz).date
}

fun LocalDate.monthNumberCompat(): Int = month.ordinal + 1

expect fun currentLocalDate(): LocalDate

expect fun currentLocalDateTime(): LocalDateTime

expect fun currentDateInTimeZone(timeZoneId: String?): LocalDate

expect fun currentDateTimeInTimeZone(timeZoneId: String?): LocalDateTime
